import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

const rendingResourcesCarousel = document.querySelectorAll(".customer-stories-carousel");

rendingResourcesCarousel.forEach((slider, index) => {
    const Carousel = slider.querySelector(".swiper");
    const prevArrow = slider.querySelector(".swiper-button-prev");
    const nextArrow = slider.querySelector(".swiper-button-next");

    new Swiper(Carousel, {
        modules: [Navigation],
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        spaceBetween: 20,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        loop: true,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            792: {
                slidesPerView: 3,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            },
        }
    });
});
